import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ZipcodeState } from './zipcode.types';

const initialState: ZipcodeState = {
  zipcode: '',
  city: '',
  state: '',
};

const zipcodeSlice = createSlice({
  name: 'zipcode',
  initialState,
  reducers: {
    updateZipcode: (state, action: PayloadAction<string>) => {
      state.zipcode = action.payload;
    },
    updateCityAndState: (
      state,
      { payload }: PayloadAction<Pick<ZipcodeState, 'city' | 'state'>>
    ) => {
      state.city = payload.city;
      state.state = payload.state;
    },
    resetZipcode: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { updateZipcode, updateCityAndState, resetZipcode } =
  zipcodeSlice.actions;

export default zipcodeSlice.reducer;
